import { Injectable } from '@angular/core';
import { IMinimumPaymtCalSharedData } from 'src/app/models/minimumPaymtCalSharedData.model';

@Injectable({
  providedIn: 'root',
})
export class SharingDataService {
  minimumPaymtCalSharedData: IMinimumPaymtCalSharedData;
  constructor() {
    this.minimumPaymtCalSharedData = {
      Nationality: true,
      MonthlyIncome: 0,
      SelectedCard: null,
      DesiredCreditLimit: 0,
      TranslatedData: null,
    };
  }
}
